import React from "react";
import "./Education.css";

const education = [
  {
    degree: "B.Tech — Computer Science & Engineering",
    institution: "Dr. Ram Manohar Lohia Awadh University (RMLAU)",
    location: "Ayodhya, Uttar Pradesh",
    period: "2020 – 2024 · Graduated Sep 2024",
    highlight: "Strong foundation in algorithms, DBMS, operating systems, and software engineering.",
    score: "78%",
    badge: "Graduate",
  },
];

const milestones = [
  { label: "GATE CSE 2026", value: "Qualified", desc: "Graduate Aptitude Test in Engineering" },
  { label: "B.Tech CSE", value: "78%", desc: "Dr. RML Awadh University" },
  { label: "Experience", value: "2+ Yrs", desc: "Production systems at IIT Kanpur" },
];

function Education() {
  return (
    <section id="education" className="education section-band">
      <div className="section-inner">
        <header className="section-header">
          <div className="section-label">Education</div>
          <h2 className="section-title">
            Academic <em>Foundation</em>
          </h2>
          <p className="section-subtitle">
            B.Tech in Computer Science & Engineering with GATE CSE 2026 qualification.
          </p>
        </header>

        <div className="edu__layout">
          <div className="edu__milestones">
            {milestones.map(({ label, value, desc }) => (
              <div key={label} className="edu__milestone ui-card reveal">
                <span className="edu__milestone-value">{value}</span>
                <strong className="edu__milestone-label">{label}</strong>
                <span className="edu__milestone-desc">{desc}</span>
              </div>
            ))}
          </div>

          <div className="edu__timeline ui-timeline">
            {education.map((item, idx) => (
              <article key={idx} className="ui-timeline__item reveal">
                <div className="ui-timeline__marker" aria-hidden="true">
                  <span className="ui-timeline__dot" />
                </div>
                <div className="edu__card-body ui-card">
                  <div className="edu__card-header">
                    <span className="ui-badge ui-badge--muted">{item.badge}</span>
                    {item.score && <span className="edu__score">{item.score}</span>}
                  </div>
                  <h3 className="card-title">{item.degree}</h3>
                  <p className="card-meta">{item.institution}</p>
                  <p className="edu__meta">{item.location} · {item.period}</p>
                  <p className="card-body edu__highlight">{item.highlight}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Education;
